// Sample schema based on tab types

const TABLE_SCHEMA = {
  pageNumber: {
    type: 'number'
  },
  sort: {
    type: 'object'
  },
  filter: {
    type: 'object'
  }
};

const IT_DOCS_LIST_SCHEME = {
  listInfo: {
    type: 'object'
  },
  selectedClient: {
    type: 'object',
    nullable: true
  },
  selectedSite: {
    type: 'object',
    nullable: true
  }
};

const intellientAlertBaseConfig = {
  'intelligentAlert.basePolicy': {
    type: 'object',
    nullable: true
  }
};
const clientSiteAssetConfig = {
  'intelligentAlert.policySetClient': {
    type: 'object',
    nullable: true
  },
  'intelligentAlert.policySetSite': {
    type: 'object',
    nullable: true
  },
  'intelligentAlert.policySetAsset': {
    type: 'object',
    nullable: true
  }
};
const GLOBAL_STATE_CONFIGURATION = {
  WORKSPACE: {
    projectGlobalFiler: {
      type: 'object',
      nullable: true
    },
    projectsListInfo: {
      type: 'object'
    },
    // adding mailbox and ticketid for classic view
    'ticket.conversation.mailbox': {
      type: 'object',
      nullable: true
    },
    classicViewTicketId: {
      type: 'object',
      nullable: true
    },
    classicViewPatchId: {
      type: 'object',
      nullable: true
    },
    classicListInfo: {
      type: 'object',
      nullable: true
    },
    classicSearchVal: {
      type: 'string',
      nullable: true
    }
  },
  TICKET: {
    activeTabIndex: {
      type: 'number'
    },
    conversation: {
      type: 'string'
    },
    schedulingShowSla: {
      type: 'boolean'
    },
    schedulingSelectedDate: {
      type: 'object'
    },
    schedulingSelectedWeekRange: {
      type: 'object'
    },
    schedulingDispatcherView: {
      type: 'boolean'
    },
    schedulingCalendarView: {
      type: 'string'
    },
    schedulingToolbarFilterConditions: {
      type: 'object'
    },
    'ticket.conversation.mailbox': {
      type: 'object',
      nullable: true
    }
  },
  CLIENT: {
    counter: {
      type: 'number'
    },
    index: {
      type: 'number'
    },
    activeClientDetailsTab: {
      type: 'number'
    },
    clientITDocsListInfo: {
      type: 'object'
    },
    clientITDocsActiveTabData: { type: 'object' },
    activeAssetView: {
      type: 'object'
    },
    requesterListInfo: {
      type: 'object'
    },
    'contract.tab': {
      type: 'number'
    },
    'contractform.state': {
      type: 'object',
      nullable: true
    },
    'contractform.tab': {
      type: 'number'
    },
    contractform: {
      type: 'boolean'
    },
    assetSummaryTopoModal: {
      type: 'boolean'
    }
    // activeItem: {
    //   type: 'number'
    // }
  },
  ALL_CLIENTS: {
    classicInvoiceListInfo: {
      type: 'object',
      nullable: true
    },
    classicViewInvoiceId: {
      type: 'object',
      nullable: true
    },
    classicSearchVal: {
      type: 'string',
      nullable: true
    }
  },
  ASSET_DETAILS: {
    ...intellientAlertBaseConfig,
    ...clientSiteAssetConfig,
    'fileExplorer.splitpane': {
      type: 'string'
    },
    assetSummaryTopoModal: {
      type: 'boolean'
    }
  },
  ALL_ASSET_DETAILS: {
    ...intellientAlertBaseConfig,
    ...clientSiteAssetConfig,
    'fileExplorer.splitpane': {
      type: 'string'
    },
    assetSummaryTopoModal: {
      type: 'boolean'
    }
  },
  ONBOARD: {
    ...intellientAlertBaseConfig,
    ...clientSiteAssetConfig,
    'template.tab': {
      type: 'number'
    },
    contractform: {
      type: 'boolean'
    },
    'contractform.tab': {
      type: 'number'
    },
    'contractform.state': {
      type: 'object',
      nullable: true
    }
  },
  PROJECT_DETAIL: {
    schedulingShowSla: {
      type: 'boolean'
    },
    schedulingSelectedDate: {
      type: 'object'
    },
    schedulingSelectedWeekRange: {
      type: 'object'
    },
    schedulingDispatcherView: {
      type: 'boolean'
    },
    schedulingCalendarView: {
      type: 'string'
    },
    schedulingToolbarFilterConditions: {
      type: 'object'
    },
    projectActiveTabIndex: {
      type: 'number'
    },
    projectActiveView: {
      type: 'string'
    }
  },
  SCHEDULING: {
    schedulingShowSla: {
      type: 'boolean'
    },
    schedulingSelectedDate: {
      type: 'object'
    },
    schedulingSelectedWeekRange: {
      type: 'object'
    },
    schedulingDispatcherView: {
      type: 'boolean'
    },
    schedulingCalendarView: {
      type: 'string'
    },
    schedulingAppointmentFormData: {
      type: 'object'
    },
    schedulingToolbarFilterConditions: {
      type: 'object'
    }
  },
  RMM_HOME: {
    options: {
      type: 'object'
    },
    columnConfig: {
      type: 'object'
    },
    config: {
      type: 'object'
    },
    classicViewPatchId: {
      type: 'object',
      nullable: true
    },
    classicSearchVal: {
      type: 'string',
      nullable: true
    }
  },
  CLIENT_IT_DOCS: { ...IT_DOCS_LIST_SCHEME },
  IT_DOCS: {
    ...IT_DOCS_LIST_SCHEME
  },
  IT_INSIGHT: {
    ...IT_DOCS_LIST_SCHEME,
    insightsActiveTabIndex: {
      type: 'number'
    },
    insightsActiveNav: {
      type: 'object',
      nullable: true
    },
    searchResults: {
      type: 'array',
      nullable: true
    },
    assetSummaryTopoModal: {
      type: 'boolean'
    }
  },
  globalState: {
    'globalConversation.activeChat': {
      type: 'string',
      nullable: true
    },
    'globalConversation.tabs': {
      type: 'object'
    },
    stripeAccountId: {
      type: 'string',
      nullable: true
    }
  }
};

// There should be solid reason to override this. Currently we will have the tabs before migration here.
const TABS_WITHOUT_STATE = [];

export { GLOBAL_STATE_CONFIGURATION, TABS_WITHOUT_STATE };
